import { useEffect, useState } from "react";
import koalaUtils from "src/helpers/koala/koalaUtils";
import { KoalaCart } from "src/types/koala/KoalaCart";
import { KoalaVariant } from "src/types/koala/KoalaVariant";

export default function useAddToCartQuantity(variant: KoalaVariant, cart: KoalaCart | null) {
  const [quantity, setQuantity] = useState<"" | number>(1);
  const [quantityError, setQuantityError] = useState<string | null>(null);

  function getInitialQuantity(variant: KoalaVariant, cart: KoalaCart) {
    const lineItem = koalaUtils.getCartItemByVariantId(cart, variant._id);
    if (lineItem) return lineItem.quantity;
    else return 1;
  }

  useEffect(
    function setInitialQuantity() {
      if (cart) {
        setQuantity(getInitialQuantity(variant, cart));
      }
    },
    [cart, variant]
  );

  return { quantity, setQuantity, quantityError, setQuantityError };
}
